<ng-scrollbar
  class="horizontal-scrollbar"
  orientation="horizontal"
  visibility=""
  position="inverterX"
  buttons="false"
>
  <a
    *ngFor="let item of items"
    type="button"
    class="btn btn-icon"
    [ngbTooltip]="(item.title || '') | translate"
    (click)="goToPage(item)"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="btn btn-icon btn-menu rounded-10 shadow">
            <i class="{{ item.icon }}"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="btn-menu-text">
          {{ (item.title || '') | translate }}
        </span>
        </div>
      </div>
    </div>
  </a>
</ng-scrollbar>
